<template>
  <div>
    <div class="form-group row">
      <label class="col-2 form-control-label"><span class="ess">작업기간</span></label>
      <div class="col-4 pt-2">
        <DatePicker class="form-control" type="date" range :append-to-body="true"
          :value="permit.workPeriod"
          :clearable="false" :editable="false"
          :disabled-date="scheduleDateDisabledFn"
          @change="(val) => { permit.workPeriod = val; }"
          style="font-size: 12px;" input-class="calendar-input">
          <i slot="icon-calendar" class="icon-calendar" style="color: #222; cursor: pointer"></i>
        </DatePicker>
      </div>
    </div>
    <!-- 취급화학물질 종류 -->
    <div class="form-group row">
      <label class="col-2 form-control-label"><span>취급화학물질 종류</span></label>
      <div class="col-10 pt-2">
        <div class="btn-wrap mb-10">
          <button class="btn btn-md light-blue" @click="addChemicalRow">
            <i class="icon-plus mr-5"></i>행 추가
          </button>
          <button class="btn btn-md line-2" @click="removeChemicalRows" :disabled="!hasCheckedRows(permit.chemicals)">
            <i class="icon-minus mr-5"></i>행 삭제
          </button>
        </div>
        <table class="tbl v-tbl">
          <colgroup>
            <col width="40px">
            <col width="50px">
            <col>
            <col>
            <col>
            <col width="160px">
          </colgroup>
          <thead class="no-drag">
            <tr>
              <th>
                <label class="md-check">
                  <input type="checkbox" v-model="chemicalCheckAll">
                  <i class="blue"></i>
                </label>
              </th>
              <th>번호</th>
              <th>취급화학물질</th>
              <th>취급방법</th>
              <th>
                <span v-tooltip.top="{ content: 'MSDS의 2번 유해·위험성 항목을 확인하여 작성하세요.', classes: ['wp-risk-tooltip'] }"
                      style="display:inline-flex; align-items:center; justify-content:center; width:15px; height:15px; border-radius:50%; background:#888; color:#fff; font-size:10px; cursor:help; margin-right:4px;">?</span>
                <span class="ess">위험성</span>
              </th>
              <th><span class="ess">MSDS 첨부</span></th>
            </tr>
          </thead>
          <tbody v-if="permit.chemicals.length === 0">
            <tr>
              <td colspan="6" style="text-align:center">데이터가 없습니다.</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr v-for="(row, index) in permit.chemicals" :key="row.id">
              <td>
                <label class="md-check">
                  <input type="checkbox" v-model="row.checked">
                  <i class="blue"></i>
                </label>
              </td>
              <td>{{ index + 1 }}</td>
              <td><input type="text" class="form-control" v-model="row.name" placeholder="취급화학물질명"></td>
              <td><input type="text" class="form-control" v-model="row.handlingMethods" placeholder="취급방법"></td>
              <td><input type="text" class="form-control" v-model="row.hazard" placeholder="위험성"
                    :style="(rowInUse(row) && !(row.hazard || '').trim()) ? { borderColor:'#eb5757' } : {}"></td>
              <td>
                <div>
                  <input type="file" :id="'msds-file-' + row.id" multiple accept=".pdf,.jpg,.jpeg,.png"
                    style="display:none" @change="handleMsdsFileChange($event, row)">
                  <button class="btn btn-sm line-2" @click="triggerMsdsUpload(row)">
                    <i class="icon-upload mr-3"></i>파일 선택
                  </button>
                  <div v-if="row.msdsFiles && row.msdsFiles.length" class="mt-5">
                    <div v-for="(f, fi) in row.msdsFiles" :key="fi" style="font-size:11px; display:flex; align-items:center; gap:4px;">
                      <span style="overflow:hidden; text-overflow:ellipsis; white-space:nowrap; max-width:110px;">{{ f.name }}</span>
                      <button class="btn btn-xs line-2" @click="removeChemicalFile(row, fi)">×</button>
                    </div>
                  </div>
                  <div v-if="rowInUse(row) && !(row.msdsFiles && row.msdsFiles.length)"
                       style="color:#eb5757; font-size:11px; margin-top:4px;">MSDS 파일 필수</div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import docFileUploadMixin from '@/mixins/docFileUploadMixin';
export default {
  name: 'ChemicalPermit',
  mixins: [docFileUploadMixin],
  inject: { workPermitPlanId: { default: () => '' } },
  data() { return { workPermitFormKey: 'chemicalPermit' }; },
  props: {
    permit: {
      type: Object,
      required: true
    },
    scheduleDateDisabledFn: {
      type: Function,
      default: () => false
    }
  },
  computed: {
    chemicalCheckAll: {
      get() {
        return this.permit.chemicals.length > 0 && this.permit.chemicals.every((row) => row.checked);
      },
      set(value) {
        this.permit.chemicals.forEach((row) => {
          row.checked = value;
        });
      }
    }
  },
  methods: {
    addChemicalRow() {
      this.permit.chemicals.push({ checked: false, id: Date.now(), name: '', handlingMethods: '', hazard: '', msdsFiles: [] });
    },
    removeChemicalRows() {
      const next = this.permit.chemicals.filter((row) => !row.checked);
      this.permit.chemicals = next.length > 0 ? next : [{ checked: false, id: Date.now(), name: '', handlingMethods: '', hazard: '', msdsFiles: [] }];
    },
    triggerMsdsUpload(row) {
      const el = document.getElementById('msds-file-' + row.id);
      if (el) el.click();
    },
    handleMsdsFileChange(event, row) {
      if (!row.msdsFiles) this.$set(row, 'msdsFiles', []);
      this.handleDocFile(event, { key: 'chemical-' + row.id, files: row.msdsFiles });
    },
    removeChemicalFile(row, index) {
      row.msdsFiles.splice(index, 1);
    },
    hasCheckedRows(list) {
      return list.some((row) => row.checked);
    },
    rowInUse(row) {
      return !!(String(row.name || '').trim() || String(row.handlingMethods || '').trim()
        || String(row.hazard || '').trim() || (row.msdsFiles && row.msdsFiles.length));
    }
  }
}
</script>